import diacritics from 'diacritics';

export const getNameSort = (name: string) => {
  return diacritics.remove(name).toLowerCase();
};
